import { AuthContextModel } from "../App";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";
import { IEmailSetting, IEmailPeriodicity, ICreateOrUpdateEmailSetting } from "../models/IEmailSetting";

export class EmailSettingApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getEmailSetting(success: (data: IEmailSetting) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IEmailSetting>(`${Utils.LIB_API_BASE_URL}/emailSetting`, success, error, final);
    }

    getEmailPeriodicities(success: (data: IEmailPeriodicity[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IEmailPeriodicity[]>(`${Utils.LIB_API_BASE_URL}/emailSetting/emailPeriodicities`, success, error, final);
    }

    createEmailSetting(data: ICreateOrUpdateEmailSetting, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emailSetting`, data, success, error, final);
    }

    updateEmailSetting(emailSettingId: number, data: ICreateOrUpdateEmailSetting, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.put(`${Utils.LIB_API_BASE_URL}/emailSetting/${emailSettingId}`, data, success, error, final);
    }

    createTestEmail(emailSettingId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emailSetting/${emailSettingId}/test`, undefined, success, error, undefined);
    }
}